import { createFileRoute } from "@tanstack/react-router";
import { Glossary } from "@/lib/lazyPages";
import { SEO, breadcrumbJsonLd } from "@/config/seoConfig";
import { definedTermSetJsonLd } from "@/content/glossary";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/glossary")({
  head: () => seoHead({
    ...SEO.glossary,
    jsonLd: [
      definedTermSetJsonLd,
      breadcrumbJsonLd([
        { name: "Home", url: "/" },
        { name: "Glossary", url: "/glossary" },
      ]),
    ],
  }),
  component: Glossary,
});
